import { JWT_TOKEN_INTERCEPTOR_PROVIDER } from '@elio/emanager-front/auth/shared';
import {
  APP_INTERCEPTOR_PROVIDER,
  ERROR_INTERCEPTOR_PROVIDER,
  HEADQUARTER_INTERCEPTOR_PROVIDER,
  NAVIGATOR_INTERCEPTOR_PROVIDER,
  OFFER_INTERCEPTOR_PROVIDER,
} from '@elio/emanager-front/shared/interceptors';

/**
 * L'ordre des intercepteurs est TRES important
 * -> Ils seront exécutés dans l'ordre DESCENDANT en SORTIE
 * -> Ils seront exécutés dans l'ordre MONTANT en ENTREE
 */
export const httpInterceptorProviders = [
  ERROR_INTERCEPTOR_PROVIDER,
  JWT_TOKEN_INTERCEPTOR_PROVIDER,
  OFFER_INTERCEPTOR_PROVIDER,
  HEADQUARTER_INTERCEPTOR_PROVIDER,
  APP_INTERCEPTOR_PROVIDER,
  NAVIGATOR_INTERCEPTOR_PROVIDER,
];
